// extracted by mini-css-extract-plugin
module.exports = {"loginLink":"styles_loginLink__67tNB","userDropdownTrigger":"styles_userDropdownTrigger__A6Cn6"};